import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export function FscOpsSeatDependencyBanner({
  onClose
}) {
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    closeable: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "fscConfigure.seatsCard.opsSeatDependencyBanner"
    })
  });
}